import { notifyParent } from 'Helpers/notifyParent'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import { PageHeader } from 'mailup-web-components'

import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router'

import { useRecoilValue } from 'recoil'
import { pageState } from '../recoil/state/page'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const [redirectUrl] = useRedirectorUrl()

  const { sourceName } = useRecoilValue(pageState)

  useEffect(() => {
    notifyParent('selectMenuItemReact', [
      'ContentsSourcesViewContents',
      redirectUrl
    ])
  }, [redirectUrl])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Automation' }),
      'data-mu-test': 'breadcrumb-item__automation',
      className: 'test-breadcrumb-item__automation'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Content' }),
      'data-mu-test': 'breadcrumb-item__content',
      className: 'test-breadcrumb-item__content',
      url: '#',
      onClick: () => history.push('/automation/sources/list')
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.ContentsSources' }),
      'data-mu-test': 'breadcrumb-item__Source',
      className: 'test-breadcrumb-item__Source',
      url: '#',
      onClick: () => history.push('/automation/sources/list')
    },
    {
      label: intl.formatMessage({ id: 'Load.ContentsSources.ViewContents' }),
      'data-mu-test': 'breadcrumb-item__ViewContents',
      className: 'test-breadcrumb-item__ViewContents'
    }
  ]

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      title={sourceName}
      loading={sourceName.length === 0}
    />
  )
}

export default Header
